import React, { FC, useCallback, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import styles from 'styles/components/card.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { OrderCardAccordionButton, OrderCardHeaderTel } from 'components/Card'
import { FlexRow } from 'components/Flex'
import { StoreCustomerModal, TelModal } from 'components/Modal'
import { Spacer } from 'components/Utility'
import { openModal } from 'reducks/modal/operations'
import { OrderTime } from 'types/checkout'
import { StoreType } from 'types/store'
import { useFetchStoreCustomer } from 'hooks/customer'
import { FirebaseDocRefType } from 'firebase/index'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { Tag } from 'components/Tag'

type Props = {
  basketNumber: string
  orderTime: OrderTime
  manufacturerNames?: string
  store?: StoreType
  tel: string
  username: string
  userId: string
}

const OrderCardHeader: FC<Props> = React.memo((props) => {
  const { basketNumber, orderTime, manufacturerNames, store, tel, username, userId } = props
  const storeRef: FirebaseDocRefType = useSelector((state: State) => getStoreRef(state))
  const dispatch = useDispatch()

  const [isDisplayed, setDisplayTel] = useState<boolean>(false)
  const [open, setOpen] = useState<boolean>(false)

  const displayTel = useCallback(() => setDisplayTel((prevState) => !prevState), [setDisplayTel])
  const openTelModal = useCallback(() => setOpen(true), [setOpen])
  const closeTelModal = useCallback(() => setOpen(false), [setOpen])

  const { storeCustomer } = useFetchStoreCustomer(storeRef, userId)
  const openStoreCustomerModal = () => {
    dispatch(openModal(<StoreCustomerModal userId={userId} />, ''))
  }

  return (
    <div className={styles.order__header}>
      <span className={styles.order__header__label}>注文番号</span>
      <Spacer size={4} />
      <h2 className={styles.order__header__number} data-cy={`order-card-header-h2-${basketNumber}`}>
        {basketNumber}
      </h2>
      {/*　スーパー管理者の注文横断検索時に表示する店舗情報　*/}
      {store && (
        <>
          <Spacer size={4} />
          <FlexRow justifyContent={'center'}>
            <img src={'/icon/blue/home.svg'} alt={''} />
            <Spacer size={4} axis={'horizontal'} />
            <span className={styles.order__header__storeName}>
              {store.name}
              {manufacturerNames && manufacturerNames !== store.name && `(${manufacturerNames})`}
            </span>
          </FlexRow>
        </>
      )}
      <Spacer size={8} />
      <FlexRow justifyContent={'center'} gap={2} wrap={'wrap'}>
        <span className={text.color_grey_01}>注文者:</span>
        <span className={text.font_bold} data-cy={`order-card-customer-${basketNumber}`}>
          {username}さま({orderTime.times}回目)
        </span>
        {storeCustomer && (
          <>
            <img src={'/icon/blue/open.svg'} alt={'お客様リストの詳細情報'} onClick={openStoreCustomerModal} />
            {storeCustomer.notes.length > 0 && <Tag color={'orange'} tagName={'ノート有り'} />}
          </>
        )}
      </FlexRow>
      <Spacer size={8} />
      {isDisplayed ? (
        <OrderCardHeaderTel tel={tel} openModal={openTelModal} />
      ) : (
        <OrderCardAccordionButton dataCy={'tel'} label={'お客さまの連絡先を表示'} toggle={displayTel} />
      )}
      <TelModal open={open} closeModal={closeTelModal} tel={tel} />
    </div>
  )
})

export default OrderCardHeader
